module.exports = __webpack_public_path__ + "static/img/helmet.5b63624.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/helmet.png
// module id = /3Sf
// module chunks = 0